export default __webpack_public_path__ + "static/media/logo-ispire talan-withe.c9e5b960.svg";